export const OneInch = [
  'function advanceEpoch(uint96,uint256)',
  'function and(uint256,bytes) view returns (bool)',
  'function arbitraryStaticCall(address,bytes) view returns (uint256)',
  'function bitInvalidatorForOrder(address,uint256) view returns (uint256)',
  'function bitsInvalidateForOrder(uint256,uint256)',
  'function cancelOrder(uint256 makerTraits, bytes32 orderHash)',
  'function cancelOrders(uint256[],bytes32[])',
  'function checkPredicate(bytes) view returns (bool)',
  'function clipperSwap(address,uint256,address,uint256,uint256,uint256,bytes32,bytes32) payable returns (uint256)',
  'function clipperSwapTo(address,address,uint256,address,uint256,uint256,uint256,bytes32,bytes32) payable returns (uint256)',
  'function curveSwapCallback(address,address,address,uint256,uint256)',
  'function eip712Domain() view returns (bytes1,string,string,uint256,address,bytes32,uint256[])',
  'function epoch(address,uint96) view returns (uint256)',
  'function epochEquals(address,uint256,uint256) view returns (bool)',
  'function eq(uint256,bytes) view returns (bool)',
  'function ethUnoswap(uint256,uint256) payable returns (uint256)',
  'function ethUnoswap2(uint256,uint256,uint256) payable returns (uint256)',
  'function ethUnoswap3(uint256,uint256,uint256,uint256) payable returns (uint256)',
  'function ethUnoswapTo(uint256,uint256,uint256) payable returns (uint256)',
  'function ethUnoswapTo2(uint256,uint256,uint256,uint256) payable returns (uint256)',
  'function ethUnoswapTo3(uint256,uint256,uint256,uint256,uint256) payable returns (uint256)',
  'function fillContractOrder(tuple(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256),bytes,uint256,uint256) returns (uint256,uint256,bytes32)',
  'function fillContractOrderArgs(tuple(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256),bytes,uint256,uint256,bytes) returns (uint256,uint256,bytes32)',
  'function fillOrder(tuple(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256),bytes32,bytes32,uint256,uint256) payable returns (uint256,uint256,bytes32)',
  'function fillOrderArgs(tuple(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256),bytes32,bytes32,uint256,uint256,bytes) payable returns (uint256,uint256,bytes32)',
  'function gt(uint256,bytes) view returns (bool)',
  'function hashOrder(tuple(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)) view returns (bytes32)',
  'function increaseEpoch(uint96)',
  'function lt(uint256,bytes) view returns (bool)',
  'function not(bytes) view returns (bool)',
  'function or(uint256,bytes) view returns (bool)',
  'function owner() view returns (address)',
  'function pause()',
  'function paused() view returns (bool)',
  'function permitAndCall(bytes,bytes) payable',
  'function rawRemainingInvalidatorForOrder(address,bytes32) view returns (uint256)',
  'function remainingInvalidatorForOrder(address,bytes32) view returns (uint256)',
  'function renounceOwnership()',
  'function rescueFunds(address,uint256)',
  'function simulate(address,bytes)',
  'function swap(address executor,tuple(address srcToken,address dstToken,address srcReceiver,address dstReceiver,uint256 amount,uint256 minReturnAmount,uint256 flags) desc,bytes data) payable returns (uint256,uint256)',
  'function transferOwnership(address)',
  'function uniswapV3SwapCallback(int256,int256,bytes)',
  'function unoswap(uint256 token, uint256 amount, uint256 minReturn, uint256 dex)  returns (uint256)',
  'function unoswap2(uint256 token, uint256 amount, uint256 minReturn, uint256 dex, uint256 dex2)',
  'function unoswap3(uint256 token,uint256 amount,uint256 minReturn,uint256 dex,uint256 dex2,uint256 dex3) returns (uint256)',
  'function unoswapTo(uint256 to,uint256 token,uint256 amount,uint256 minReturn,uint256 dex) returns (uint256)',
  'function unoswapTo2(uint256,uint256,uint256,uint256,uint256,uint256) returns (uint256)',
  'function unoswapTo3(uint256,uint256,uint256,uint256,uint256,uint256,uint256) returns (uint256)',
  'function unpause()',
  'function swap(address executor, tuple(address srcToken, address dstToken, address srcReceiver, address dstReceiver, uint256 amount, uint256 minReturnAmount, uint256 flags) desc, bytes permit, bytes data) payable returns (uint256 returnAmount, uint256 spentAmount)'
]
